import { array, boolean, number, object, string } from 'yup';

export const productSchema = object().shape({
  id: number().required(),
  code: string().required(),
  name: string().required(),
  sectionIds: array().ensure().of(number().required()).required(),
  picture: string().nullable(),
  altPicture: string().nullable(),
  volume: string().nullable(),
  isAvailable: boolean().required(),
  addToBasketId: number().nullable(),
  xmlId: string().required(),
  refillId: number().required().nullable(),
  secret: boolean().optional(),
  priceInfo: object()
    .shape({
      price: number().required(),
      basePrice: number().nullable(),
      startsFrom: boolean().required(),
    })
    .required(),
  isNew: boolean().optional(),
  previewMode: boolean().optional(),
  // Участник акции «2+1»: бейдж на карточке + фильтр каталога/страница акции.
  // default(false) — бэкенд без акции (или до деплоя) не должен ронять валидацию.
  isTwoPlusOne: boolean().default(false),
  sortMain: number()
    .transform((val) => val ?? 500)
    .default(500),
  badges: array()
    .of(
      object().shape({
        type: string().required(),
        text: string().required().nullable(),
      }),
    )
    .optional()
    .nullable(),
});
